import { render, staticRenderFns } from "./quality_list.vue?vue&type=template&id=bd7afa2a&scoped=true"
import script from "./quality_list.vue?vue&type=script&lang=js"
export * from "./quality_list.vue?vue&type=script&lang=js"
import style0 from "./quality_list.vue?vue&type=style&index=0&id=bd7afa2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7afa2a",
  null
  
)

export default component.exports